export default __webpack_public_path__ + "static/media/feature-3.cd090c5d.png";